module.exports = __webpack_public_path__ + "img/porto-2.afda5537.png";